import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/auth/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TimeoutError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorsService } from '../../../shared/services/errors.service';

@Component({
  selector: 'hs-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  public form: FormGroup;
  loading = false;
  timeoutError = false;
  submitted = false;
  success = false;
  error = null;

  key: string;
  user: string;

  constructor(
    private formBuilder: FormBuilder,
    private auth: AuthService,
    private route: ActivatedRoute,
    private errorsService: ErrorsService
  ) {}

  ngOnInit(): void {
    this.key = this.route.snapshot.queryParamMap.get('key');
    this.user = this.route.snapshot.queryParamMap.get('login');
    this.form = this.formBuilder.group(
      {
        password: ['', [Validators.required, Validators.minLength(3)]],
        confirmPassword: ['', Validators.required],
      }
    );
  }

  reset() {
    this.loading = true;
    this.auth.resetPassword(this.form.value.password, this.key, this.user).subscribe(response => {
      this.success = true;
      this.submitted = false;
      this.loading = false;
    }, error => {
      // show error if user exists or if there is another generic error
      if (error instanceof TimeoutError) {
        this.timeoutError = true;
      } else if (error instanceof HttpErrorResponse) {
        this.error = error.error;
      }
      this.submitted = false;
      this.form.reset();
      this.form.enable();
      this.loading = false;

      this.errorsService.track(error);
    });
  }
}
